import { axiosClient } from "@/shared/api/axios-client";

export interface NivelAutorizacion {
  id: string;
  tipo: string;
  subtipo: string;
  areaId: string;
  nivel: number;
  rolesAutorizadores: string[];
  /**
   * Si es true, la póliza TXT se genera al APROBARSE este nivel (no al enviar a
   * autorización). Por defecto (ningún nivel del flujo marcado) la póliza se
   * genera al enviar. Ver "flujo de autorización · momento de generación de póliza".
   */
  generaPolizaAlAprobar: boolean;
}

export interface CrearNivelAutorizacionInput {
  tipo: string;
  subtipo: string;
  areaId: string;
  nivel: number;
  rolesAutorizadores: string[];
  generaPolizaAlAprobar: boolean;
}

export async function listarNivelesAutorizacion(): Promise<NivelAutorizacion[]> {
  const { data } = await axiosClient.get<NivelAutorizacion[]>(
    "/api/admin/flujos-autorizacion"
  );
  return data;
}

export async function crearNivelAutorizacion(
  input: CrearNivelAutorizacionInput
): Promise<NivelAutorizacion> {
  const { data } = await axiosClient.post<NivelAutorizacion>(
    "/api/admin/flujos-autorizacion",
    input
  );
  return data;
}

export async function actualizarRolesNivel(
  id: string,
  roles: string[],
  generaPolizaAlAprobar: boolean
): Promise<void> {
  await axiosClient.patch(`/api/admin/flujos-autorizacion/${id}/roles`, {
    roles,
    generaPolizaAlAprobar,
  });
}

/**
 * Aplica el flag "generar póliza al aprobar" a TODOS los niveles que comparten
 * (tipo, subtipo, nivel) en cualquier área · toca solo el flag, respeta los roles
 * propios de cada área. Devuelve cuántos niveles se actualizaron.
 */
export async function establecerGeneraPolizaEnNivel(input: {
  tipo: string;
  subtipo: string;
  nivel: number;
  generaPolizaAlAprobar: boolean;
}): Promise<number> {
  const { data } = await axiosClient.patch<{ afectados: number }>(
    "/api/admin/flujos-autorizacion/genera-poliza",
    input
  );
  return data.afectados;
}

export async function eliminarNivelAutorizacion(id: string): Promise<void> {
  await axiosClient.delete(`/api/admin/flujos-autorizacion/${id}`);
}
